import { render, staticRenderFns } from "./DisplayDropdown.vue?vue&type=template&id=f0b65d72&"
import script from "./DisplayDropdown.vue?vue&type=script&lang=js&"
export * from "./DisplayDropdown.vue?vue&type=script&lang=js&"
import style0 from "./DisplayDropdown.vue?vue&type=style&index=0&id=f0b65d72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports